import Config from '../../utils/Config';

class Testimonials extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            current : 0,
            uuid    : uuid(),
            timer   : false
        };

        this.showSlide = this.showSlide.bind(this);
    }

    componentDidMount() {
        var self = this;

        $('.testimonials__wrapper').css({ width : (this.props.content.details.length * 100)+'%' });

        this.setState({
            timer : setInterval(function() {
                self.showSlide(false)
            }, 6000)
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
        this.setState({ timer : false });
    }

    showSlide(slide) {
        var self    = this;
        var details = this.props.content.details;

        var next = slide !== false ? slide : this.state.current + 1;

        if (next === details.length) {
            next = 0;
        }

        for (var i=0; i<details.length; i++) {
            if (next === i)
                $('.testimonials-dot'+i).addClass('testimonials__controls--current');
            else
                $('.testimonials-dot'+i).removeClass('testimonials__controls--current');
        }

        var left = -1 * next * 100;

        this.setState({
            current : next
        }, function() {
            $('.testimonials__wrapper').animate({
                'left' : left+'%'
            }, 500);
        });
    }

    render() {
        var self    = this;
        var content = this.props.content;

        return (
            <section
                className='section testimonials'
                id='testimonials'>

                <div className='testimonials__content'>

                    <div className='testimonials__wrapper'>
                        { content.details.map(function(testimonial, i) {
                            return (
                                <div
                                    className='testimonials__slide'
                                    key={'slide_'+i}
                                    style={{'width' : (100 / content.details.length)+'%'}}>

                                    <p dangerouslySetInnerHTML={{__html: testimonial.content}} />

                                    <div className='testimonials__person'>
                                        <img src={'/public/codi-studios/testimonials/'+testimonial.img+'.jpg'} />

                                        <div className='testimonials__person--name'>
                                            {testimonial.name}
                                        </div>

                                        <div className='testimonials__person--position'>
                                            {testimonial.position}
                                        </div>

                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>

                <div style={{ 'clear' : 'both' }} />

                <ul className='testimonials__controls'>
                    { content.details.map(function(details, i) {
                        return (
                            <li
                                className={'testimonials__controls--dot testimonials-dot'+i}
                                onClick={self.showSlide.bind(self, i)}
                                key={'testimonials-dot_'+i} />
                        );
                    })}
                </ul>

            </section>
        );
    }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./ui_src/app/components/testimonials/Testimonials.react.jsx